<template>
    <v-card>
        <v-toolbar dark color="primary">
            <v-btn 
                icon 
                dark 
                :disabled="submitLoading" 
                @click="cancel">
                <v-icon large>close</v-icon>
            </v-btn>
            <v-spacer></v-spacer>
            <v-toolbar-title>
                <span v-if="editing">Edit Allowance Type</span>
                <span v-else>Add New Allowance Type</span>
            </v-toolbar-title>
            <v-spacer></v-spacer>
        </v-toolbar>

        <v-form ref="editForm" v-model="editValid">
            <v-layout class="dialog-content">
                <v-flex xs12 md6 offset-md3 mt-4>
                    
                    <v-layout wrap>                        
                        <v-flex xs12>
                            <v-text-field 
                                box
                                clearable
                                label="Name"
                                v-model="editData.AllowanceTypeName" 
                                :rules="[rules.required]">
                            </v-text-field>
                        </v-flex>
                        <v-flex xs12>
                            <v-checkbox 
                                label="Active"
                                v-model="editData.Active">
                            </v-checkbox>
                        </v-flex>
                    </v-layout>
                    
                    <v-layout wrap class="dialog-action-buttons">
                        <v-flex xs12 sm6>
                            <v-btn 
                                block 
                                color="success" 
                                :disabled="!editValid" 
                                :loading="submitLoading" 
                                @click="submit">
                                <span>Save</span>
                            </v-btn>
                        </v-flex>
                        <v-flex xs12 sm6>
                            <v-btn 
                                block 
                                color="error" 
                                :disabled="submitLoading" 
                                @click="cancel">
                                <span>Cancel</span>
                            </v-btn>
                        </v-flex>
                        <v-flex xs12>
                            <v-alert 
                                :value="submitError != null" 
                                outline 
                                type="error">
                                <span>{{ submitError }}</span>
                            </v-alert>
                        </v-flex>
                    </v-layout>
                </v-flex>
            </v-layout>
        </v-form>

    </v-card>    
</template>

<script>

import validationRules from "@/helpers/validationrules";

export default {
    components: {
        
    },
    props: {
        item: {
            required: true,
            type: Object
        },
        submitError: {
            required: false,
            type: String
        },
        submitLoading: {
            required: false,
            type: Boolean
        }
    },
    data(){
        return {
            rules: validationRules.rules,
            editData: {},
            editValid: false,
            error: null   
        }
    },
    computed: {
        editing() {
            return this.editData.AllowanceTypeID != null;
        }
    },
    methods: {
        cancel() {
            this.$emit("cancel");
        },
        submit() {
            this.$emit("submit", this.editData);
        }
    },
    async created() {
        this.editData = JSON.parse(JSON.stringify(this.item));
    }
}
</script>